import React from 'react';
import { Form, Card, Spinner, Alert } from 'react-bootstrap';

const InsuranceInfo = ({
  formData,
  handleChange,
  providers,
  useHardcodedProvider,
  setUseHardcodedProvider,
  loadingProviders
}) => {
  return (
    <div>
      <h3 className="h5 mb-3">Insurance & Provider Information</h3>
      
      {/* Yellow Privacy Notice Alert */}
      <Alert variant="warning" className="mb-3">
        <div className="d-flex">
          <div className="me-2">
            <i className="bi bi-info-circle"></i>
          </div>
          <div className="small">
            <strong>Privacy Notice:</strong> Insurance and Social Security Number information is not mandatory at this stage. If you have privacy concerns, you may choose to provide this information later when visiting the clinic in person.
          </div>
        </div>
      </Alert>
      
      <Form.Group controlId="insurance" className="mb-3">
        <Form.Label>Insurance Name</Form.Label>
        <Form.Control
          type="text"
          name="bio.insurance_name"
          value={formData.patient.bio.insurance_name}
          onChange={handleChange}
          placeholder="Insurance provider name"
        />
      </Form.Group>
      
      <Form.Group controlId="ssn" className="mb-3">
        <Form.Label>Social Security Number</Form.Label>
        <Form.Control
          type="text"
          name="bio.ssn"
          value={formData.patient.bio.ssn}
          onChange={handleChange}
          placeholder="XXX-XX-XXXX"
        />
        <Form.Text className="text-muted">
          For your security, please only provide your SSN if you're comfortable doing so.
        </Form.Text>
      </Form.Group>
      
      <Card className="bg-light mb-3">
        <Card.Body>
          <Form.Check
            type="checkbox"
            id="useHardcoded"
            label="Use default provider"
            checked={useHardcodedProvider}
            onChange={() => setUseHardcodedProvider(!useHardcodedProvider)}
            className="mb-3"
          />
          
          {useHardcodedProvider ? (
            <Form.Group controlId="hardcodedId">
              <Form.Label>Provider</Form.Label>
              {loadingProviders ? (
                <div className="d-flex align-items-center text-muted">
                  <Spinner animation="border" size="sm" className="me-2" />
                  <span>Loading providers...</span>
                </div>
              ) : (
                <Form.Control
                  type="text"
                  value={providers.length > 0 ? providers[0].name : "Default Provider"}
                  disabled
                  placeholder="Default provider"
                /> 
              )}
            </Form.Group>
          ) : (
            <Form.Group controlId="providerSelect">
              <Form.Label>Select Provider<span className="text-danger">*</span></Form.Label>
              {loadingProviders ? (
                <div className="d-flex align-items-center text-muted">
                  <Spinner animation="border" size="sm" className="me-2" />
                  <span>Loading providers...</span>
                </div>
              ) : (
                <Form.Select
                  name="provider_id"
                  value={formData.provider.provider_id}
                  onChange={handleChange}
                  required={!useHardcodedProvider}
                >
                  <option value="">Select a provider</option>
                  {providers.map(provider => (
                    <option key={provider.id} value={provider.id}>
                      {provider.name}
                    </option>
                  ))}
                </Form.Select>
              )}
            </Form.Group>
          )}
        </Card.Body>
      </Card>
    </div>
  );
};

export default InsuranceInfo;